import * as dateFNS from 'date-fns'

export const isSameDay = (...args) => dateFNS.isSameDay(...args)
